export class DependencyNotReadyError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'DependencyNotReadyError'
  }
}

// 의존 대상(부모 결함)이 서버 검증 거절로 멈춘 상태 — 재시도해도 풀리지 않으므로 job을 끝낸다.
// 부모가 다시 저장돼 생성되면 부모 onIdMap이 다시 큐에 넣는다.
export class DependencyRejectedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'DependencyRejectedError'
  }
}
